import { render, staticRenderFns } from "./BS5837.vue?vue&type=template&id=a97ff82a&scoped=true&"
import script from "./BS5837.vue?vue&type=script&lang=js&"
export * from "./BS5837.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a97ff82a",
  null
  
)

export default component.exports